// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'clipboard-check';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M3.938 7.883h3.937m-3.937 2.813h2.25m-2.25 2.812h2.25m1.125 3.93H1.688a1.125 1.125 0 0 1-1.125-1.125V4.5a1.125 1.125 0 0 1 1.125-1.125H4.5a2.813 2.813 0 0 1 5.625 0h2.813A1.125 1.125 0 0 1 14.062 4.5v1.688' />
    <path d='M7.313 3.383a.281.281 0 0 1 0-.562m0 .562a.281.281 0 0 0 0-.562m5.625 14.617a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z' />
    <path d='m14.943 11.629-2.179 2.905a.562.562 0 0 1-.848.06L10.79 13.47' />
  </g>
);

export const viewBox = '0 0 18 18';
